<template>
  <div class="payment-link">
  
      <div class="payment-body-main-wrapper">
        <PaymentBody  ref="paymentBody" :class="{'secondary-form': !showSecondaryFrom}" />
        <Footer v-if="showSecondaryFrom" />
         <v-btn
          v-if="showMobileLayout && showSecondaryFrom"
            class="proceed-btn"
            color="primary"
            width="100%"
            height="55px"
            @click.prevent="proceedPayment"

          >
            Proceed to pay
          </v-btn>
      </div>
  
  </div>
</template>
<script>
import Notice from "./components/Notice";
import PaymentBody from "./components/PaymentBody";
import Footer from "./components/Footer";
export default {
  name: "PaymentLink",
  components: {
    Notice,
    PaymentBody,
    Footer
  },
  data() {
    return {
      showMobileLayout: false,
      showSecondaryFrom: true,
      isProceed: false,
      windowWidth: window.innerWidth
    };
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.onResize();
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
      if(this.windowWidth < 768 && !this.isProceed) {
        this.showMobileLayout = true;
      } 
    },
    proceedPayment () {
      this.$refs.paymentBody.showPaymentForm();
      this.$refs.paymentBody.updateStep();
       this.showSecondaryFrom = false;
       this.isProceed = true;
    }
  }
};
</script>
